/* eslint-disable @typescript-eslint/dot-notation */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'live-support-btn',
  template: `
    <a
      (click)="show()"
      class="intercom"
      data-category="Help"
      [attr.data-label]="'help-menu.labels.live_support' | translate"
    >
      <svg class="icon icons-master-expanded_icon-help-chat">
        <use href="#img-sprite_icons-master-expanded_icon-help-chat"></use></svg
      ><span>{{ 'help-menu.labels.live_support' | translate }}</span></a
    >
  `,
})
export class LiveSupportBtnComponent {
  @Input() message: string;

  show() {
    if (window['Intercom']) {
      window['Intercom']('showNewMessage', this.message);
    }
  }
}
